$(function () {
    if ($('#cart-summary').length) {
        new Vue({
            store: store,
            el: '#cart-summary',
            data: {
                ready: false
            },
            computed: {
                cartSummary: function () {
                    return this.$store.state.cartSummary;
                },
            },
            methods: {
                formatPrice: function (price) {
                    if (price) {
                        var formatter = new Intl.NumberFormat('en-US', {
                            style: 'currency',
                            currency: 'USD',
                        });

                        return formatter.format(price);
                    }
                    return '--';
                }
            },
            mounted: function () {
                var vm = this;
                this.$store.dispatch('updateCartSummary').then(function (resp) {
                    vm.ready = true;
                });
            }
        });
    }
});